$.ready(function() {
	/* global spinClear, spinInit, spinReady, spinDone */
	
	var feature = game.feature = $.div('feature').appendTo(game);
	
	feature.messages = $.div().addClass('messages');
	
	var messages = feature.messages2 = $.div().addClass('messages');
	messages.overall = $.div().apply('meter', {}).addClass('overall').appendTo(messages);
	
	feature.showMessage = function(type, value, noHide) {
		if (typeof value === 'number') {
			messages.overall.set(value);
			messages.overall.removeClass('hide');
		}
		
		else {
			messages.overall.addClass('hide');
		}
		
		feature.messages.removeClass('hide');
		messages.attr('class', 'messages ' + type);
		if (!noHide) {
			game.panel.hide(true);
		}
	};
	
	feature.hideMessages = function() {
		messages.addClass('hide');
		feature.messages.addClass('hide');
		
		game.panel.show(true);
	};
	
	game.features = {};
	
	game.feature.active = false;
	
	game.feature.begin = function(key) {
		game.old = game.last;
		
		game.feature.active = key;
		
		var bonus = game.features[key];
		
		if (!bonus) {
			game.panel.dialog.show('fatal');
			
			return;
		}
		
		game.sounds.fade([ 'background' ], 1, 0, 0.5);
		game.sounds.play('bell');
		
		setTimeout(function() {
			feature.attr('class', 'active');
			
			game.panel.disable(key);
			messages.appendTo(bonus);
			
			bonus.methods.init();
			feature.messages.appendTo(feature);
			bonus.appendTo(feature);
			
			game.controller.socket.emit('feature', { name: key, action: 'begin' });
			
			setTimeout(function() {
				game.addClass('bonus');
			}, game.last.quickTransition ? 0 : 1000);
		}, game.last.quickTransition ? 0 : 3000);
	};
	
	game.feature.finish = function() {
		var last = game.last;
		
		game.last = game.old;
		game.last.win += last.win;
		game.last.credits = last.credits;
		game.last.raw = game.last.raw || last.raw;
		
		game.sounds.stop(game.feature.active);
		game.sounds.fade([ 'background' ], 0, 1, 0.5);
		
		game.feature.active = false;
		
		spinClear(true);
		spinInit(true);
		spinReady(true);
		game.removeClass('bonus');
		feature.removeClass('show');
		
		if (game.panel.type === 'desktop') {
			game.panel.play.addClass('base');
			game.panel.spin.appendTo(game.panel.play);
		}
		
		if (game.panel.type === 'mobile') {
			game.panel.play.addClass('icon-spin');
		}
		
		setTimeout(function() {
			feature.empty();
			feature.attr('class', null);
			spinDone();
			
			game.feature.hideMessages();
		}, game.last.quickTransition ? 0 : 1000);
	};
	
	game.on('ui', function() {
		game.panel.registerCash(messages.overall, true);
	});
	
	game.controller.socket.on('feature', function(response) {
		var bonus = game.features[response.name];
		
		if (!bonus) {
			game.panel.dialog.show('fatal');
			
			return;
		}
		
		if (response.action === 'begin') {
			if (game.panel.type === 'desktop') {
				game.panel.spin.remove();
				game.panel.play.removeClass('base');
				game.panel.play.addClass(bonus.key);
			}
			
			if (game.panel.type === 'mobile') {
				game.panel.play.removeClass('icon-spin');
			}
			
			feature.addClass('show');
		}
		
		else if (response.action === 'spin') {
			game.spin(response);
		}
		
		game.last = response;
		
		if (bonus.methods[response.action]) {
			bonus.methods[response.action](response);
		}
		
		if (response.action === 'finish') {
			if (game.panel.type === 'desktop') {
				game.panel.play.removeClass(bonus.key);
			}
		}
	});
});



/** WEBPACK FOOTER **
 ** ./../../public-src/common/js/feature.js
 **/